import {
  pollTrackerBulkloadJob,
  startTrackerBulkloadImport,
} from "utils/trackerBulkload";
import axios from "api/axios";

function extractFileResourceId(responseData) {
  return (
    responseData?.response?.fileResource?.id ||
    responseData?.response?.id ||
    responseData?.fileResource?.id ||
    responseData?.id ||
    ""
  );
}

export async function uploadTrackerFileResource(file) {
  if (!(file instanceof File)) {
    return file || "";
  }

  const formData = new FormData();
  formData.append("file", file);

  const response = await axios.post("/fileResources", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  const fileResourceId = extractFileResourceId(response?.data);

  if (!fileResourceId) {
    throw new Error("The file was uploaded, but no file reference was returned.");
  }

  return fileResourceId;
}

export async function submitTrackerRegistration(
  payload,
  { importStrategy = "CREATE_AND_UPDATE", onStatus } = {},
) {
  const { jobId, response } = await startTrackerBulkloadImport(payload, { importStrategy });
  const report = await pollTrackerBulkloadJob(jobId, { onStatus });

  return {
    jobId,
    response,
    report,
  };
}
